import { Reducer } from 'redux';
import { CidadeOrigemState, CidadeOrigemTypes } from './types';

const INITIAL_STATE: CidadeOrigemState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<CidadeOrigemState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CidadeOrigemTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CidadeOrigemTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case CidadeOrigemTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case CidadeOrigemTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
